import axios from 'axios';

import {
  requestInterceptHandler,
  responseInterceptErrorHandler,
} from '@/components/shared/utility/axios';

const clientAxios = axios.create({
  baseURL: `${process.env.HOST}/api/lead`,
  method: 'post',
});

clientAxios.interceptors.request.use(requestInterceptHandler);
clientAxios.interceptors.response.use(
  (response) => response,
  responseInterceptErrorHandler
);

export default clientAxios;
